module.exports = __webpack_public_path__ + "static/media/everyday_digital_and_weekend_papers_june23.18637e41.webp";